import * as jose from 'jose';
import { failureLogin, requestLogin, successLogin } from '../../actions/AuthActions';
import { addConfig } from '../../actions/ConfigActions';
import store from '../../store/store';
import { getUserDataToken } from '../../util/userUtils';

const LOGIN_JWT_ALG = 'RS256';

export const verifyLoginToken = async (appConfig, studySearchConfig) => {
  try {
    // Keep the access loading state active while the JWT is verified.
    store.dispatch(requestLogin());
    const publicKey = await jose.importSPKI(appConfig.LOGIN_JWT_PUBLIC_KEY, LOGIN_JWT_ALG);
    const userDataToken = getUserDataToken();
    if (userDataToken === null) {
      console.log('User Token is empty');
      store.dispatch(failureLogin());
      return;
    }

    const userDataDecoded = await jose.jwtVerify(userDataToken, publicKey);
    if (!userDataDecoded.payload) return;

    if (appConfig.authorizationHeader === null) {
      store.dispatch(addConfig({ authorizationHeader: userDataToken }));
    }
    if (userDataDecoded.payload.studySearchConfig) {
      studySearchConfig.userFilters = userDataDecoded.payload.studySearchConfig.userFilters ?? studySearchConfig.userFilters;
      studySearchConfig.searchFilters = userDataDecoded.payload.studySearchConfig.searchFilters ?? studySearchConfig.searchFilters;
      studySearchConfig.searchColumns = userDataDecoded.payload.studySearchConfig.searchColumns ?? studySearchConfig.searchColumns;
    }
    store.dispatch(successLogin(userDataDecoded.payload.username));
  } catch (error) {
    console.error('Verify Token Error: ', error);
    store.dispatch(failureLogin());
  }
};
